import { render, staticRenderFns } from "./StudentsTransactions.vue?vue&type=template&id=668e31be"
import script from "./StudentsTransactions.vue?vue&type=script&lang=js"
export * from "./StudentsTransactions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports